class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * @description Called when the element is added to the DOM
   */
  connectedCallback() {
    // Clic sur les boutons de quantité
    const quantity_buttons = this.querySelectorAll(".quantity_button");
    if (quantity_buttons) {
      quantity_buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          const input = button.closest(".cart_drawer_item").querySelector("input[name='updates[]']");
          const min = input.getAttribute("data-min");
          if (button.name === "minus") {
            // Empêche la suppression via les boutons
            if (parseInt(input.value) <= min) {
              input.value = min;
              return;
            }
            input.stepDown();
          } else if (button.name === "plus") {
            input.stepUp();
          }
          input.dispatchEvent(new Event("change"));
        });
      });
    }

    // Clic sur le bouton de suppression
    const remove_buttons = this.querySelectorAll(".cart_drawer_item_remove");
    if (remove_buttons) {
      remove_buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          this.update_quantity(button.dataset.index, 0);
        });
      });
    }

    // Gestion du groupement des appels pour la modification de quantité
    const debounced_on_change = debounce((event) => {
      if (event.target.reportValidity()) {
        this.update_quantity(event.target.dataset.index, event.target.value, "updates[]", event.target.dataset.variant_id);
      }
    }, 300);

    // Changement de quantité
    const quantity_inputs = this.querySelectorAll("input[name='updates[]']");
    if (quantity_inputs) {
      quantity_inputs.forEach((input) => {
        input.addEventListener("change", debounced_on_change);
      });
    }
  }

  /**
   * @description Affiche les messages d'erreur pour une ligne donnée
   * @param {number} line - L'index de l'item dans le panier
   * @param {string} msg - Le message d'erreur à afficher
   */
  show_errors(line, msg) {
    const lineItemError = document.getElementById(`drawer_qty_${line}`).closest(".cart_drawer_item_wrapper").querySelector(".cart_drawer_item_error");
    if (lineItemError) lineItemError.textContent = msg;
  }

  /**
   * @description Met à jour la quantité d'un item dans le panier
   * @param {number} line - L'index de l'item dans le panier
   * @param {number} quantity - La nouvelle quantité
   * @param {string} name - Le nom du champ de formulaire
   * @param {string} variant_id - L'id de la variante
   */
  update_quantity(line, quantity, name, variant_id) {
    const sections_to_render = this.sections_to_render();
    const body = JSON.stringify({
      line,
      quantity,
      sections: sections_to_render.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...{ method: "POST", headers: { "Content-Type": "application/json", Accept: `application/json` } }, ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsed_state = JSON.parse(state);
        const quantity_element = document.getElementById(`drawer_qty_${line}`);
        const items = document.querySelectorAll(".cart_drawer_item");

        // Si il y a des erreurs, on affiche les messages d'erreur et on annule la modification de quantité
        if (parsed_state.errors) {
          quantity_element.value = quantity_element.getAttribute("value");
          this.show_errors(line, parsed_state.errors);
          return;
        }

        const cart_drawer_wrapper = document.querySelector("cart_drawer");
        const cart_footer = document.getElementById("main-cart-footer");

        if (cart_footer) cart_footer.classList.toggle("is-empty", parsed_state.item_count === 0);
        if (cart_drawer_wrapper) cart_drawer_wrapper.classList.toggle("is-empty", parsed_state.item_count === 0);

        sections_to_render.forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          const new_html = new DOMParser().parseFromString(parsed_state.sections[section.section], "text/html").querySelector(section.selector).innerHTML;
          elementToReplace.innerHTML = new_html;

          // On retire puis replace les scripts présents dans les sections
          const scripts = elementToReplace.querySelectorAll("script");
          scripts.forEach((script) => {
            script.remove();
          });
          const new_scripts = new DOMParser().parseFromString(parsed_state.sections[section.section], "text/html").querySelectorAll("script");
          new_scripts.forEach((script) => {
            elementToReplace.appendChild(script);
          });
        });
        const updatedValue = parsed_state.items[line - 1] ? parsed_state.items[line - 1].quantity : undefined;
        let message = "";
        if (items.length === parsed_state.items.length && updatedValue !== parseInt(quantity_element.value)) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
          }
        }
        // this.updateLiveRegions(line, message);

        /* const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cart_drawer_wrapper ? trapFocus(cart_drawer_wrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsed_state.item_count === 0 && cart_drawer_wrapper) {
        trapFocus(cart_drawer_wrapper.querySelector(".drawer__inner-empty"), cart_drawer_wrapper.querySelector("a"));
      } else if (document.querySelector(".cart-item") && cart_drawer_wrapper) {
        trapFocus(cart_drawer_wrapper, document.querySelector(".cart-item__name"));
      } */

        // publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: parsed_state, variantId: variantId });
      })
      .catch((error) => {
        /* this.querySelectorAll(".loading__spinner").forEach((overlay) => overlay.classList.add("hidden"));
      const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      errors.textContent = window.cartStrings.error; */
      })
      .finally(() => {
        // this.disableLoading(line);
      });
  }

  /**
   * @description Retourne les sections à rendre après un call ajax (Mise à jour de la quantité)
   * @returns {Array}
   */
  sections_to_render() {
    return [
      {
        id: "cart_drawer",
        section: "cart-drawer",
        selector: ".cart_drawer",
      },
      {
        id: "header_cart_count",
        section: "header-cart-count",
        selector: "sup",
      },
    ];
  }

  render_contents(parsedState) {
    this.closest(".drawer_content").classList.contains("cart_drawer_content_empty") && this.closest(".drawer_content").classList.remove("cart_drawer_content_empty");
    this.productId = parsedState.id;
    this.sections_to_render().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.get_section_inner_html(parsedState.sections[section.section], section.selector);
    });

    setTimeout(() => {
      //this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      this.open();
    });
  }

  get_section_inner_html(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  open() {
    const wrapper = document.getElementById("cart_drawer");

    // Ouverture de l'overlay
    $(wrapper.closest(".overlay_full")).fadeIn(100, () => {
      // Ouverture du drawer
      wrapper.setAttribute("data-state", "open");
    });
  }

  close() {
    const wrapper = this.closest(".cart_drawer");
    wrapper.setAttribute("data-state", "closed");
    $(wrapper.closest(".overlay_full")).fadeOut(100);
  }
}

customElements.define("cart-drawer", CartDrawer);
